module.exports = __webpack_public_path__ + "static/media/exafan.c4408558.jpg";